import { ControlMapper, ControlTagMapper } from "@/models/control.model";
import { Currency } from "@/shared/value-objects/currency.vo";
import { getControlList } from "@/spz-api/controls/controls";
import type { GetControlListParams } from "@/spz-api/model";
import type { IControlRepository } from "../interfaces/control-repository.interface";

export class ControlRepository implements IControlRepository {
  async getControlsAndTags(params: GetControlListParams) {
    const response = await getControlList(params);
    const currency = response.relationships.currencies[0] ?? Currency.EUR;

    return {
      controls: ControlMapper.toListItems(
        response.data,
        response.relationships,
      ),
      tags: ControlTagMapper.toItems(response.relationships.tags),
      currency: Currency.create(currency),
    };
  }
}
